import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import CategoryWithValue from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/RegularAndOvertime/CategoryWithValue'

import InfoBox from './InfoBox'
import { calculateTimeForLegend } from './utils/calculateTimeForLegend'

interface Props {
  minutes: number
  estimatedRegularMinutes: number
  breaksMinutes: number
}

const Planned: React.FC<{ regular: number; breaksMinutes: number }> = ({
  regular,
  breaksMinutes,
}) => (
  <Box gap="s4">
    <InfoBox
      color="viridian1000"
      text={i18n.t('clock_in.sidepanel.regular_and_overtime.planned')}
      value={regular}
    />
    <BreakTime breaksMinutes={breaksMinutes} />
    <Text color="grey800" size="100">
      {i18n.t('clock_in.sidepanel.regular_and_overtime.descriptions.planned')}
    </Text>
  </Box>
)

const Worked: React.FC<{ regular: number; breaksMinutes: number }> = ({
  regular,
  breaksMinutes,
}) => (
  <Box gap="s4">
    <InfoBox
      color="viridian1000"
      text={i18n.t('clock_in.sidepanel.regular_and_overtime.worked')}
      value={regular}
    />
    <BreakTime breaksMinutes={breaksMinutes} />
    <Text color="grey800" size="100">
      {i18n.t('clock_in.sidepanel.regular_and_overtime.descriptions.worked')}
    </Text>
  </Box>
)

const Overtime: React.FC<{ overtime: number }> = ({ overtime }) => (
  <Box gap="s4">
    <InfoBox
      color="tangerine1000"
      text={i18n.t('clock_in.sidepanel.regular_and_overtime.overtime')}
      value={overtime}
    />
    <Text color="grey800" size="100">
      {i18n.t('clock_in.sidepanel.regular_and_overtime.descriptions.overtime')}
    </Text>
  </Box>
)

const RemainingTime: React.FC<{ remaining: number }> = ({ remaining }) => (
  <Box gap="s4">
    <InfoBox
      color="grey400"
      text={i18n.t('clock_in.sidepanel.regular_and_overtime.to_be_completed')}
      value={remaining}
    />
    <Text color="grey800" size="100">
      {i18n.t('clock_in.sidepanel.regular_and_overtime.descriptions.to_be_completed')}
    </Text>
  </Box>
)

const BreakTime: React.FC<{ breaksMinutes: number }> = ({ breaksMinutes }) => {
  return breaksMinutes > 0 ? (
    <Box paddingLeft="s24">
      <CategoryWithValue
        title={i18n.t('clock_in.sidepanel.regular_and_overtime.paid_breaks')}
        value={breaksMinutes}
      />
    </Box>
  ) : null
}

const Legend: React.FC<Props> = ({ minutes, estimatedRegularMinutes, breaksMinutes }) => {
  const { regular, overtime, remaining } = calculateTimeForLegend(minutes, estimatedRegularMinutes)
  const hasOvertime = overtime > 0

  return (
    <Box gap="s12">
      {hasOvertime ? (
        <Planned regular={regular} breaksMinutes={breaksMinutes} />
      ) : (
        <Worked regular={regular} breaksMinutes={breaksMinutes} />
      )}
      {hasOvertime ? <Overtime overtime={overtime} /> : <RemainingTime remaining={remaining} />}
    </Box>
  )
}

export default Legend
